
import '../style.css';
import Carousel from './carousel'
import GuanteoCard from './GuanteoCard.jsx'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import MayoristaModal from './MayoristaModal';
import FaqSection from './FaqSection';
import { FaYoutube, FaInstagram, FaGlobe } from 'react-icons/fa';


function Index() {

const [showModal, setShowModal] = useState(false);
   
     return ( 
       <div className="indexprincipal">
   
       

        <div className="top-banner d-flex justify-content-between align-items-center px-3 py-2">
          {/* Imagen a la izquierda */}
          <div className="banner-image">
            <img src="pez2.png" alt="Personaje Guanteo" className="img-fluid" />
             <img src="pez4.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>

          {/* Título del juego */}
          <div className="banner-title text-center flex-grow-1">
            <img src="Logo-cardumenes-blanco.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>

          {/* Logo editorial a la derecha */}
          <div className="banner-logo">
            <img src="pez1.png" alt="Personaje Guanteo" className="img-fluid" />
             <img src="pez3.png" alt="Personaje Guanteo" className="img-fluid" />
          </div>
        </div>

        <Carousel/> 

        <Container fluid className="py-4">
          <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8}>
              <div className="guanteo-descripcion">
                <h2 className='bungee-regular'>🐟 Cardúmenes: Planificá tu estrategia y Dominá las profundidades.</h2>
                <p>
                  <strong>Un duelo táctico cara a cara donde cada decisión cuenta.</strong><br /><br />
                  En <strong>Cardúmenes</strong>, dos jugadores se enfrentan en un tablero submarino donde el <strong>posicionamiento</strong>, <strong>la gestión de Energía</strong> y la <strong>estrategia táctica</strong> definen la partida. Desplegá tus unidades, rompé las líneas enemigas y controlá el ritmo de la partida.<br /><br />
                  🎯 <strong>¿El objetivo?</strong><br />
                 Capturá al <strong>Hipocampo rival</strong> y escoltalo hasta tu base… o superá a tu oponente demostrando una supremacía táctica clara en el campo de batalla.<br /><br />
                  ⚡ <strong>Decisiones con costo real</strong><br />
                 Cada turno obtenés Energía al tirar los dados, y debés decidir cómo usarla: mover unidades, atacar, activar habilidades o jugar cartas. No hay acciones gratuitas y cada jugada cuenta.<br /><br />
                  🧠 <strong>Lectura del tablero y control del espacio</strong><br />
                 Empujes, embestidas, parálisis y otras habilidades convierten cada casillero en una amenaza. Una mala ubicación puede costarte una unidad; una jugada precisa puede definir la partida.<br /><br />
                 🃏 <strong>Una capa extra de profundidad</strong><br />
                 Un mercado que ofrece modificadores y efectos especiales que amplían las posibilidades tácticas a cambio de tus valiosos puntos de Energía. No es imprescindible, pero quien aprenda a usarlo hará su Juego aún más poderoso.<br /><br />

                  ⚠️ <strong>No gana quien más avanza, sino quien entiende cómo hacerlo estratégicamente.</strong>
                </p>

                 <div className="manual-cta text-center mt-4">
              <p className="mb-3">Descubrí las reglas completas en el manual y preparate para el duelo</p>
              <Button  size="lg" href="/Reglamento Guanteo.pdf" target="_blank" className="guanteo-btn">
                📖 Ver Manual
              </Button>
            </div>
              </div>
              
            </Col>
          </Row>
           <Row>
           
          </Row>
     
      </Container>

        <Container>
          <Container className="my-5">
             <h2 className="text-center guanteo-subtitulo mt-5">
        📹 Cardúmenes: Como se juega
      </h2>
    
             <Row className="g-4 justify-content-center">
              {/*<Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="logo192.png"
                  description="Aprendé las reglas básicas y cómo empezar a jugar Guanteo en 5 minutos."
                  videoLink="https://www.youtube.com/watch?v=video1"
                />
              </Col>*/}
              <Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="fondovideo.png"
                  description="Te Contamos Como Jugar"
                  videoLink="https://youtu.be/igyrygoI9g0?si=OhHZbfoc2hY1KGXG"
                />
              </Col>
              {/*<Col xs={12} md={6} lg={4}>
                <GuanteoCard
                  image="logo192.png"
                  description="Consejos avanzados para mejorar tu memoria y usar combos a tu favor."
                  videoLink="https://www.youtube.com/watch?v=video3"
                />
              </Col>*/}
            </Row>
           
          </Container>
      
        <Container fluid className="guanteo-banner mt-5 py-5">
        <Row className="justify-content-center text-center">
          <Col xs={12} md={10} lg={8}>
            <h3 className="guanteo-banner-title mb-4">
              ¿Listo para Dominar el Océano?<br></br> ¡Conseguí tu Cardúmenes hoy!
            </h3>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              <Button 
                variant="warning" 
                size="lg" 
                href="https://www.tienda.kitsunegames.ar/productos/guanteo/"
                className="guanteo-banner-btn"
              >
                🛒 Ir a la Tienda
              </Button> 
             
                  <Button 
              variant="outline-light" 
              size="lg" 
              onClick={() => setShowModal(true)}
              className="guanteo-banner-btn"
            >
              🧾 Venta Mayorista
            </Button>

            <MayoristaModal show={showModal} handleClose={() => setShowModal(false)} />
                  </div>
                </Col>
        </Row>
      </Container>


        <FaqSection />

        <footer className="footer text-white py-4">
  <div className="container">
    <div className="row text-center text-md-start align-items-center">

      {/* Logo y nombre de la editorial */}
      <div className="col-md-3 mb-4 mb-md-0 d-flex flex-column align-items-center">
        <img
          src="Logosnorkel.png"
          alt="Logo Editorial"
          className="footer-editorial-logo mb-2"
        />
       
      </div>

      {/* Nombre del juego y tagline */}
      <div className="col-md-6 mb-4 mb-md-0 text-center">
        <img src="Logo-cardumenes-blanco.png" alt="Logo cardúmenes" className="logo-cardumenes-footer" />
        <p className="mb-2">Estrategia, despliegue y captura en las profundidades</p>
        <div className="social-icons d-flex justify-content-center gap-3">
          <a
            href="https://www.youtube.com/@Kitsunegamesar"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube size={24} />
          </a>
          <a
            href="https://www.instagram.com/kitsunegames.ar/"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.kitsunegames.ar"
            className="text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGlobe size={24} />
          </a>
        </div>
      </div>

      {/* Leyenda de derechos */}
      <div className="col-md-3 text-center text-md-end">
        <p className="mb-1">© {new Date().getFullYear()} Editorial KitsuneGames</p>
        <p className="mb-0">Todos los derechos reservados.</p>
      </div>
    </div>
  </div>
</footer>


</Container>
       </div>
       
     );
   }
   
   export default Index;